export const DEFAULT_ORDER_LIST_FILTERS = {
  search: '',
  orderNo: '',
  designNo: '',
  chalanNo: '',
  party: '',
  broker: '',
  khata: '',
  concept: '',
  category: '',
  beamColor: '',
  orderStatus: '',
};

/** Options for Order status dropdown — value '' = any */
export function getOrderWorkflowFilterOptions() {
  return [
    { value: '', label: 'All statuses' },
    { value: 'DRAFT', label: 'Draft' },
    { value: 'APPROVED', label: 'Approved' },
    { value: 'PLACE_ORDER', label: 'Place order' },
    { value: 'IN_PRODUCTION', label: 'In production' },
    { value: 'PRODUCTION_DONE', label: 'Completed' },
    { value: 'BUTTA_CUTTING', label: 'Butta cutting' },
    { value: 'MILL_FINISH', label: 'Mill finish' },
    { value: 'BORDER_CUTTING', label: 'Border cutting' },
    { value: 'HANDWORK', label: 'Handwork' },
    { value: 'READY_FOR_DISPATCH', label: 'Ready for dispatch' },
    { value: 'IN_STOCK', label: 'In stock' },
    { value: 'DISPATCHED', label: 'Dispatched' },
    { value: 'DELIVERED', label: 'Delivered' },
    { value: 'CANCELLED', label: 'Cancelled' },
  ];
}

/** Normalize legacy / partial filter objects. */
export function normalizeOrderListFilters(filters) {
  const f = { ...DEFAULT_ORDER_LIST_FILTERS, ...filters };
  const legacyOrderNo = String(f.orderNo || f.orderId || '').trim();
  const legacySearch = [f.search, f.generalSearch]
    .map((s) => String(s || '').trim())
    .filter(Boolean)
    .join(' ');

  return {
    search: legacySearch || String(f.search || '').trim(),
    orderNo: legacyOrderNo,
    designNo: String(f.designNo || '').trim(),
    chalanNo: String(f.chalanNo || '').trim(),
    party: String(f.party || '').trim(),
    broker: String(f.broker || '').trim(),
    khata: String(f.khata || '').trim(),
    concept: f.concept || '',
    category: f.category || '',
    beamColor: String(f.beamColor || '').trim(),
    orderStatus: f.orderStatus || '',
  };
}

/*
 * Filtering itself happens on the server (GET /api/orders, see backend
 * OrderListQueryRepository) with the same rules the list used to apply in the browser.
 */

export function countActiveOrderFilters(filters) {
  const f = normalizeOrderListFilters(filters);
  let n = 0;
  if (String(f.search || '').trim()) n += 1;
  if (String(f.orderNo || '').trim()) n += 1;
  if (String(f.designNo || '').trim()) n += 1;
  if (String(f.chalanNo || '').trim()) n += 1;
  if (String(f.party || '').trim()) n += 1;
  if (String(f.broker || '').trim()) n += 1;
  if (String(f.khata || '').trim()) n += 1;
  if (String(f.concept || '').trim()) n += 1;
  if (String(f.category || '').trim()) n += 1;
  if (String(f.beamColor || '').trim()) n += 1;
  if (f.orderStatus && f.orderStatus !== '') n += 1;
  return n;
}

/** Read `?status=` from the orders URL (dashboard deep-links). */
export function readOrderStatusFromSearch(search) {
  const params = new URLSearchParams(search || '');
  return params.get('status') || '';
}

/** Build `/orders` path with optional workflow status filter. */
export function ordersPathWithStatus(statusKey) {
  const base = '/orders';
  if (!statusKey) return base;
  return `${base}?status=${encodeURIComponent(statusKey)}`;
}

export function ordersNewPath() {
  return '/orders/new';
}

export function ordersDetailPath(orderId) {
  return `/orders/${encodeURIComponent(String(orderId))}`;
}

/**
 * Parse `/orders`, `/orders/new`, or `/orders/:id` from the location pathname.
 * @returns {{ screen: 'list' | 'new' | 'detail', orderId?: string }}
 */
export function parseOrdersRoute(pathname) {
  const trimmed = String(pathname || '').replace(/\/+$/, '') || '/orders';
  if (trimmed === '/orders') {
    return { screen: 'list' };
  }
  if (trimmed === '/orders/new') {
    return { screen: 'new' };
  }
  if (trimmed.startsWith('/orders/')) {
    const segment = decodeURIComponent(trimmed.slice('/orders/'.length));
    if (segment && segment !== 'new') {
      return { screen: 'detail', orderId: segment };
    }
  }
  return { screen: 'list' };
}

/** @deprecated Prefer ordersDetailPath + navigate; kept for legacy state redirects. */
export function ordersOpenOrderState(orderId, selectDesignId) {
  const state = { openOrderId: orderId };
  if (selectDesignId != null && selectDesignId !== '') {
    state.selectDesignId = selectDesignId;
  }
  return state;
}

/** React Router navigate target to open an order (optionally pre-select a design). */
export function ordersOpenOrderTarget(orderId, selectDesignId) {
  const state = {};
  if (selectDesignId != null && selectDesignId !== '') {
    state.selectDesignId = selectDesignId;
  }
  return {
    pathname: ordersDetailPath(orderId),
    state: Object.keys(state).length > 0 ? state : undefined,
  };
}
